import type { FaireThemeEntity } from "../../entity_types/theme";

export const fayetteville_game_day_glam: FaireThemeEntity = {
  token: "fayetteville-game-day-glam",
  type: "theme",
  name: "Fayetteville Game Day Glam",
  description: "Elevate your local fan gear with sparkling accessories that show off Razorback pride. Perfect for your Fayetteville pop-up shop during the high-energy sports season.",
  teaser: "As a retailer based in Fayetteville, AR, you are in the heart of Razorback territory. Your focus on clothing and accessories makes team-licensed jewelry a high-demand addition for your local customer base.",
  detail: "The additional_context payload includes Arkansas Razorbacks Rhinestone Enamel Logo Earrings, which serves as a primary anchor for a localized game day theme.",
  bgColor: "#F0D4C4",
  tileBgColor: "#6b3838",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_9ebbrg5tvp",
    "p_rs8jx57yku",
    "p_jzs3432huv",
    "p_4kq9rh396f",
    "p_mb4beqw8nq",
    "p_jd2qsdk5du",
    "p_rbttydqudv",
    "p_xqcwustfnr",
    "p_m47ktwazvd",
    "p_safcg3yevd",
    "p_xnpu6ku5qh",
    "p_jz9gugwpcy",
    "p_6s37x2vgpn",
    "p_hfxz6w7aa7",
    "p_76xfwbsrfp",
    "p_eg25fg7pbz",
    "p_2xx7d54z23",
    "p_uph79faf4n",
    "p_ypu4x7tg6e",
    "p_xf6ybmz9x3",
    "p_4kn9e9uva6",
    "p_rubhhs2set",
    "p_svcf8asuzq",
    "p_uj9zeufq55",
    "p_8attxksy9u",
    "p_pvj6h44s4c",
    "p_tsv44jnde3",
    "p_fwappbqpqq",
    "p_t6w6yvxnyf",
    "p_s47cxjrzds",
    "p_y6hnsueepn",
    "p_cc2bs338gf",
    "p_7vud7n8te9",
    "p_gpzxtpntyt",
    "p_f2vgrthtn9",
    "p_qxjv478msj",
    "p_ss32by86xz",
    "p_sbpaa8fux3",
    "p_9635xn788b",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
